<template>
  <div>
    <div class="query-bar">
      <el-date-picker v-model="query.fDate" type="date" value-format="yyyy-MM-dd" placeholder="库存日期" size="small" style="width:130px;" />
      <el-input v-model="query.fBatchNo" placeholder="生产批号" size="small" style="width:200px;" clearable />
      <el-date-picker v-model="query.fDate_Sc" type="date" value-format="yyyy-MM-dd" placeholder="生产日期" size="small" style="width:130px;" />
      <el-date-picker v-model="query.fDate_Xd" type="date" value-format="yyyy-MM-dd" placeholder="消毒日期" size="small" style="width:130px;" />
      <el-input v-model="query.fRetroactiveNo" placeholder="追溯号" size="small" style="width:200px;" clearable />
      <el-button type="primary" size="small" @click="refresh">查询</el-button>
    </div>
    <el-table v-loading="loading" :data="tableData" @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="55" />
      <el-table-column prop="fDate" label="库存日期" :formatter="dateFormat" />
      <el-table-column prop="fBatchNo" label="生产批号" />
      <el-table-column prop="fDate_Sc" label="生产日期" :formatter="dateFormat" />
      <el-table-column prop="fDate_Xd" label="消毒日期" :formatter="dateFormat" />
      <el-table-column prop="fRetroactiveNo" label="追溯号" />
      <el-table-column prop="fQty" label="即时库存数" />
      <el-table-column prop="fLockQty" label="锁库数" />
      <el-table-column prop="fOtherPhQty" label="其它订单配货数" />
      <el-table-column prop="fKyQty" label="可用库存数" />
      <el-table-column label="配货数">
        <template slot-scope="scope">
          <el-input-currency v-model="scope.row.fPhQty" :scale="0" style="width:70px" />
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      style="margin-top:10px"
      :current-page.sync="query.pageIndex"
      :page-size.sync="query.pageSize"
      :page-sizes="[20, 50, 100, 500]"
      layout="total, sizes, prev, pager, next, jumper"
      :total="this.pageRecordTotal"
      @size-change="refresh"
      @current-change="refresh"
    />
  </div>
</template>
<script>
import moment from 'moment'

export default {
  model: {
    prop: 'value',
    event: 'changeVal'
  },
  props: {
    value: Array,
    fEntryID: Number,
    visible: Boolean
  },
  data() {
    return {
      query: {
        fDate: null,
        fBatchNo: null,
        fDate_Sc: null,
        fDate_Xd: null,
        fRetroactiveNo: null,

        pageIndex: 1,
        pageSize: 20
      },
      pageRecordTotal: 0,

      tableData: [],
      loading: false
    }
  },
  watch: {
    visible: function(v) {
      if (v) {
        this.refresh()
      }
    }
  },
  mounted: function() {
    this.refresh()
  },
  methods: {
    refresh() {
      this.loading = true
      this.query.fEntryID = this.fEntryID
      this.$httpPost('OrderManage/OrderForCcbc/GetInventorys', this.query).then((res) => {
        if (!res.isSuccess) {
          this.$message.error(res.message)
          return
        }
        this.tableData = res.datalist.dataEntry
        this.pageRecordTotal = res.datalist.total
      })
        .finally(() => this.loading = false)
    },
    handleSelectionChange(val) {
      console.log(val, 'val')
      this.$emit('changeVal', val)
    },
    dateFormat: function(row, column, cellValue) {
      const date = cellValue
      if (date == undefined || date == 'Invalid date') {
        return ''
      }
      return moment(date).format('YYYY-MM-DD')
    }
  }
}
</script>
